import React, {PropTypes} from 'react';
import { connect } from 'react-redux'
// LOCAL
import MainContentHome from './MainContentHome'


const mapStateToProps = ({
   models: {
     user: {
       subscription,
       hasMobileApp,
       isPremium,
       customer,
       trial_days_remaining
     }
   }
 }) => {

  let productIdentifier = ""
  if (subscription && subscription.product_identifier) {
    productIdentifier = subscription.product_identifier
  }
  return {
    hasMobileApp,
    productIdentifier,
    isPremium,
    trial_days_remaining: customer
      ? customer.trial_days_remaining
      : trial_days_remaining
  }
}

export default connect(mapStateToProps)(MainContentHome)



// WEBPACK FOOTER //
// ./src/home/HomePage.js